import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { StatusInput } from './statusinput';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { StatusinputService } from './statusinput.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-statusinput',
  templateUrl: './statusinput.component.html',
  styleUrls: ['./statusinput.component.css']
})

export class StatusinputComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'StatusInput';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  statusinputForm: FormGroup;
  statusInputs: StatusInput[] = [];
  statusInputsactive: StatusInput[] = [];
  statusInput: StatusInput;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  statusInputModalRef: BsModalRef;
  operation: string;
  userid: number;
  //branchid: number;
  submitted = false;
  //active: number;
  //unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  showall: boolean = true;
  showallstatus: boolean = false;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered'

  }

  constructor(
    private statusinputservice: StatusinputService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('StatusInput_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('StatusInput_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('StatusInput_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('StatusInput_action');
    } 
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.statusinputForm = this.formBuilder.group({
      statusinputid: [''],
      statusinput: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  key: string = 'statusinput'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.statusinputservice.Get().subscribe(res => {
      this.statusInputs = res;
      if (this.showallstatus == true) {
        this.statusInputs.forEach(data => {
          if (data.active == 1) {
            this.statusInputsactive.push(data);
          }
        });
        this.statusInputs = [];
        this.statusInputs = this.statusInputsactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }
  getactiveinactive(showallp) {
    this.statusInputsactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.statusInputs.forEach(data => {
        if (data.active == 1) {
          this.statusInputsactive.push(data);
        }
      });
      this.statusInputs = [];
      this.statusInputs = this.statusInputsactive;
    }
    else {
      this.showall = true;
      this.statusInputs = [];
      this.getAll();
    }
  }
  get g() { return this.statusinputForm.controls; }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedstatusinput");
    let data = arrays.find(ob => ob['name'] === 'Status Input');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedstatusinput","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedstatusinput",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.statusInputModalRef.hide();
  }

  Post(stsinput: StatusInput) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.statusinputForm.invalid) {
      //console.log(this.g);
      // console.log(this.branchForm.errors);
    }

    if ((stsinput.statusinput.trim() == undefined) || (stsinput.statusinput.trim() == '')) {
      this.toastr.error('allocation should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    stsinput.statusinput = stsinput.statusinput.trim();
    if (this.operation == 'add') {

      stsinput.createdby = this.userid;
      msg = "Record Added Successfully";
      this.statusinputservice.Post(stsinput).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.statusInputModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      stsinput.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.statusinputservice.Put(stsinput).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.statusInputModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    // console.log(this.allocationForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.statusinputForm.value.active = 1;
    } else {
      this.statusinputForm.value.active = 0
    }
  }

  OpenConfirmTemplate(stsinput) {
    if (stsinput.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.statusInput = stsinput;

          this.Delete();

        }

      });

  }


  Delete() {

    var msg;
    if (this.statusInput.active == 0) {
      this.statusInput.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.statusInput.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.statusInput.modifiedby = this.userid;

    this.statusinputservice.Delete(this.statusInput).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }



  hidePopup() {
    this.statusInputModalRef.hide();
  }
  openStatusInputModal(template: TemplateRef<any>, type, stsinput?: StatusInput) {


    this.operation = type
    if (type == 'update') {
      this.statusinputForm.controls['statusinputid'].setValue(stsinput.statusinputid);
      this.statusinputForm.controls['statusinput'].setValue(stsinput.statusinput);
      this.statusinputForm.controls['active'].setValue(stsinput.active);
      this.statusInput = stsinput;
    }
    if (type == 'add') {
      this.statusinputForm.controls['statusinputid'].setValue(0);
      this.statusinputForm.controls['statusinput'].setValue('');
      this.statusinputForm.controls['active'].setValue(1);
    }
    this.statusInputModalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }


}
